import { db } from './../../lib/firebase'
import axios from 'axios'
export const Chat = {
	namespaced: true,

	state: {
		chats: [],
		actual_chat: false,
		active: false,
		loading: true,
		sending_message: false,
		user: false
	},

	mutations: {
		set_loading        : (state, status) => state.loading          = status,
		set_active         : (state, status) => state.active           = status,
		set_chats          : (state, chats) => state.chats             = chats,
		set_actual_chat    : (state, actual_chat) => state.actual_chat = actual_chat,
		set_sending_message: (state, status) => state.sending_message  = status,
		set_user           : (state, user) => state.user               = user,
	},

	actions: {
		async get_user({ commit }) {
			let user = await axios.get('/get_user')
			commit('set_user', (user.data))
		},

		async get_chats({ commit }) {
			commit('set_loading', true)
			db.collection('chats')
				// .orderBy('to_read', "desc")
				.orderBy('update_at', "desc")
				.onSnapshot(snap => {
					commit('set_chats', snap.docs.map(doc => doc.data()))
					commit('set_loading', false)
				})
		},

		async get_actual_chat({ commit }, chat) {
			const chat_id = chat.id.toString()
			db.collection(`chats/${chat_id}/messages`)
				.orderBy('created_at', "asc")
				.onSnapshot(async snap => {
					commit('set_actual_chat', {
						chat: chat,
						messages: snap.docs.map(doc => doc.data())
					})
					await db.doc(`chats/${chat_id}`).update({ 'to_read': 0 })
				})
		},

		async send_message({ commit }, data) {
			commit('set_sending_message', true)
			
			let message_ref = await db.collection(`chats/${data.chat.id}/messages`)
				.add(data.message)
			let current_date = moment()
				.format('YYYY-MM-DD HH:mm:ss')
			
			await message_ref.update({
				id: message_ref.id,
				created_at: current_date
			})
			
			await db.doc(`chats/${data.chat.id}`)
				.update({ 'update_at': current_date })
			commit('set_sending_message', false)
		}
	}
}